<template>
    <div class="pt-button-group">
      <slot></slot>
    </div>
  </template>
  <script lang='ts'>
  import { defineComponent } from 'vue'
  export default defineComponent({
    name: 'PtButtonGroup',
  })
  </script>
  <style lang="scss" src="../style/button-group.scss"></style>